import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Nowy produkt',
  tabs: {
    [Tab.General]: 'Ogólne',
    [Tab.NutritionInfo]: 'Informacje żywieniowe',
  },
  form: {
    categories: {
      label: 'Kategorie',
    },
    printer: {
      label: 'Drukarka',
    },
    name: {
      label: 'Nazwa',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Opis',
      placeholder: '180g wołowy kotlet, sałata, pomidory, ogórki, jalapeños i sos yuppi',
    },
    external_id: {
      label: 'Ref. {{integration}}',
      placeholder: 'np. kod SKU HubRise',
      read_only_hint: 'Edytowalne tylko gdy integracja HubRise jest podłączona i synchronizacja menu jest wyłączona.',
    },
    price: {
      label: 'Cena podstawowa',
    },
    has_smart_pricing: {
      label: 'Specjalne ceny dla odbioru i dostawy',
    },
    pickup_price: {
      label: 'Cena odbioru',
      placeholder: 'Nie podano',
    },
    delivery_price: {
      label: 'Cena dostawy',
      placeholder: 'Nie podano',
    },
    image: {
      label: 'Zdjęcie (opcjonalne)',
    },
    has_combo_tax: {
      label: 'Podatek combo',
    },
    is_available: {
      label: 'Dostępny',
      subtitle: 'Widoczny w menu',
    },
    is_visible: {
      label: 'Widoczny',
      title: 'Widoczny w menu',
      subtitle_on: 'Klienci mogą zobaczyć ten produkt',
      subtitle_off: 'Ukryty dla wszystkich klientów',
    },
    is_available_for_pickup: {
      label: 'Dostępny do odbioru',
      subtitle_on: 'Klienci mogą zamawiać na wynos',
      subtitle_off: 'Ukryty w menu odbioru',
    },
    is_available_for_delivery: {
      label: 'Dostępny do dostawy',
      subtitle_on: 'Klienci mogą zamawiać z dostawą',
      subtitle_off: 'Ukryty w menu dostawy',
    },
    modifiers: {
      label: 'Modyfikatory',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'Po aktualizacji wszystkie istniejące reguły inteligentnych cen dla tego produktu zostaną nadpisane.',
    smart_pricing_remove_warning:
      'Po zapisaniu wszystkie istniejące reguły inteligentnych cen dla tego produktu zostaną usunięte.',
  },
  availability: {
    title: 'Dostępność',
    helper:
      'Widoczność to główny przełącznik. Wyłącz kanał, aby ukryć produkt przed klientami odbioru lub dostawy bez usuwania go z menu.',
    status: {
      both: 'Oba kanały',
      pickup_only: 'Tylko odbiór',
      delivery_only: 'Tylko dostawa',
      hidden: 'Ukryty',
      no_channels: 'Brak kanałów',
    },
    warning: {
      no_channels: 'Ten produkt jest widoczny, ale niedostępny w żadnym kanale — klienci nie będą mogli go zamówić.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Tylko odbiór',
      delivery_only: 'Tylko dostawa',
      no_channels: 'Brak kanałów',
    },
  },
  buttons: {
    save: 'Zapisz',
    close: 'Zamknij',
  },
  toasts: {
    changes_got_saved: 'Zmiany zostały pomyślnie zapisane!',
  },
};
